import moment from 'moment';
import dayjs, { utc } from 'dayjs';
import duration from 'dayjs/plugin/duration';

import { dateFormat, timeFormat } from './coverageRequestConstants';
import {
  isNullOrUndefined,
  isTinymceEditorContentEmpty,
} from 'src/utils/common';
import { getCurrentDateTimeWithOffset } from 'src/utils/datepickerHelper';

dayjs.extend(duration);

// to convert time in 12 hr format
function convertTo12HourFormat(time: any) {
  const dummyDate = '2000-01-01 ';
  const formattedTime = `${dummyDate}${time}`;
  const timeObj = moment(formattedTime, 'YYYY-MM-DD HH:mm:ss');
  return timeObj.format(timeFormat);
}

// to check end time is less than start time
function isEndTimeAfterStartTime(startTime: any, endTime: any) {
  return moment(endTime, timeFormat).isBefore(moment(startTime, timeFormat));
}

//Required field check for the basic fields section
function isEndTimeSameAsStartTime(startTime: any, endTime: any) {
  return moment(endTime, timeFormat).isSame(moment(startTime, timeFormat));
}

//check if all values are present
function hasAllValuesPresent(
  obj: Record<string, any>,
  isProtocallUser: boolean,
  userMode: string,
): boolean {
  const {
    StartTime,
    EndTime,
    TimeZoneId,
    ExtraCoverageDate,
    ExtraCoverageRequestTypeId,
    ExtraCoverageRequestStatusId,
    OpensNextDayDate,
    ClosesDayBeforeDate,
  } = obj;

  return (
    // other than approve user mode there start time and end time is not required one
    (userMode !== 'Approve' &&
      (ExtraCoverageRequestTypeId === '7' ||
        ExtraCoverageRequestTypeId === 7) &&
      (!StartTime || !EndTime)) ||
    (userMode === 'Approve' &&
      isProtocallUser &&
      (!StartTime || !EndTime || !OpensNextDayDate || !ClosesDayBeforeDate)) ||
    ExtraCoverageRequestTypeId === undefined ||
    !ExtraCoverageDate ||
    !TimeZoneId ||
    TimeZoneId === '-1' ||
    TimeZoneId === -1 ||
    (isProtocallUser &&
      ExtraCoverageRequestStatusId === '2' &&
      (!ExtraCoverageRequestTypeId || ExtraCoverageRequestTypeId === '-1'))
  );
}

//check if reason is submitted or not
function requestDetailsValidation(obj: Record<string, any>): boolean {
  const obj1: Record<string, any> = { ...obj };
  if (
    obj1.hasOwnProperty('ReasonForCoverage') &&
    obj1.hasOwnProperty('SpecialProcedures')
  ) {
    const isFieldEmpty: boolean =
      isTinymceEditorContentEmpty(obj1['ReasonForCoverage']) ||
      obj1['ReasonForCoverage'] === undefined ||
      obj1['SpecialProcedures'] === undefined ||
      (obj1['SpecialProcedures'] === true &&
        isTinymceEditorContentEmpty(obj1['SpecialProcedureMemo']?.trim()));

    if (isFieldEmpty) return true;
    else return false;
  }
  return true;
}

function timeDifferenceInHours(createdOn: any, time: any, utcOffset: any) {
  const timestamp1 = createdOn.concat(' ').concat(time);
  const timestamp2 = getCurrentDateTimeWithOffset(utcOffset);

  const date1 = dayjs(timestamp1, 'MM/DD/YYYY HH:mm');
  const date2 = dayjs(timestamp2, 'MM/DD/YYYY HH:mm');
  const diffMilliseconds = date1.diff(date2);
  const diffHours = diffMilliseconds / (1000 * 60 * 60);

  return diffHours;
}

function isPastDate(createdOn: string): boolean {
  return (
    Date.parse(createdOn) <
    Date.parse(dayjs().startOf('day').format(dateFormat))
  );
}

// If next day is Saturday (6) or Sunday (0), adjust to Monday:
// To compute the next working day
function computeOpensNext(date: any, startTime: any) {
  let hours = 0;
  let minutes = 0;
  if (startTime && typeof startTime === 'string' && startTime.includes(':')) {
    [hours, minutes] = startTime.split(':').map(Number);
  }
  let nextDay = dayjs(date).add(1, 'day');
  if (nextDay.day() === 6) nextDay = nextDay.add(2, 'days');
  if (nextDay.day() === 0) nextDay = nextDay.add(1, 'day');
  return nextDay.hour(hours).minute(minutes).toDate();
}

// To compute the previous working day
function computeClosesBefore(date: any, endTime: any) {
  let hours = 0;
  let minutes = 0;
  if (endTime && typeof endTime === 'string' && endTime.includes(':')) {
    [hours, minutes] = endTime.split(':').map(Number);
  }
  let nextDay = dayjs(date).subtract(1, 'day');
  if (nextDay.day() === 6) nextDay = nextDay.subtract(1, 'day');
  if (nextDay.day() === 0) nextDay = nextDay.subtract(2, 'days');
  return nextDay.hour(hours).minute(minutes).toDate();
}

//function to compute the next businessday day as string in day,month date format
function getNextBusinessDay(date: any) {
  return dayjs(date).format('ddd, MMM D');
}

function editorContent(
  reason: string,
  comments: string,
  duration: string,
  isDefault: boolean,
  procedure: string,
  nextBusinessDay: any,
): string {
  return ` <span>
          <strong style="pointer-event: none;" contenteditable="false">EXTRA COVERAGE ALERT</strong>
          </span> <br/>
          
            <strong style="pointer-event: none;" contenteditable="false">REASON:</strong> ${reason.replace(
              /<[^>]*>/g,
              '',
            )}
         <br />
          <span style="pointer-event: none;" contenteditable="false">
            <strong >DURATION:</strong> ${duration}
          </span>
           <br />
          ${
            isDefault && procedure !== null && procedure !== ''
              ? `<span style="pointer-event: none;" contenteditable="false">
            <strong >Special Procedures:</strong> ${
              procedure.replace(/<[^>]*>/g, '').trim() ?? ''
            }
          </span><br/>`
              : ''
          }         
          ${
            !isDefault
              ? `<strong style="pointer-events: none;" contenteditable="false">ADDITIONAL COMMENTS:</strong>
                <ul style="margin: 0px 0; padding-left: 19px;">
               ${
                 nextBusinessDay
                   ? ` <li>Next Business Day is ${nextBusinessDay} </li>`
                   : ''
               }
           <li>Follow standard after-hours procedures </li>        
      ${
        comments
          ? `<li><span>${comments.replace(/<[^>]*>/g, '').trim()}</span></li>`
          : ''
      }</ul> `
              : `<strong style="pointer-events: none;" contenteditable="false">ADDITIONAL COMMENTS:</strong>
              <ul style="margin: 0px 0; padding-left: 19px;">
               ${
                 nextBusinessDay
                   ? ` <li>Next Business Day is ${nextBusinessDay}</li>`
                   : ''
               }               
               ${
                 comments
                   ? `<li>${comments.replace(/<[^>]*>/g, '').trim()}</li>`
                   : ''
               }
                 </ul>`
          }      
        `;
}

export {
  convertTo12HourFormat,
  isEndTimeAfterStartTime,
  hasAllValuesPresent,
  requestDetailsValidation,
  timeDifferenceInHours,
  isPastDate,
  editorContent,
  computeOpensNext,
  computeClosesBefore,
  isEndTimeSameAsStartTime,
  getNextBusinessDay,
};
